import PropTypes from 'prop-types';
import { FormHelperText, makeStyles, Typography } from '@material-ui/core';
import ActionButton from '../actionButton';
import { ACTION_BUTTON_TYPES } from '../actionButton/config';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  buttons: {
    display: 'flex',
    alignItems: 'center',
  },
  input: {
    minWidth: 20,
    display: 'flex',
    justifyContent: 'center',
    marginRight: spacing(4),
    marginLeft: spacing(4),
  },
  labelWrapper: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: spacing(2),
  },
  iconButton: {
    width: 56,
    height: 40,
    borderColor: primary.bluish3,
    '& g path': {
      fill: `${primary.bluish3} !important`,
    },
  },
  errorMessage: {
    bottom: -20,
  },
}));

const NumberStepper = ({
  translations,
  field = {},
  value = null,
  errorMessage = '',
  hasError = false,
  onChange,
}) => {
  const classes = useStyles();

  const onDecrement = () => {
    onChange(value - 1);
  };

  const onIncrement = () => {
    onChange(value + 1);
  };

  return (
    <div>
      <div className={classes.labelWrapper}>
        <Typography variant="body2">
          {translations[field.translationKey].label}
        </Typography>
      </div>
      <div className={classes.buttons}>
        <ActionButton
          className={classes.iconButton}
          type={ACTION_BUTTON_TYPES.MINUS_ONE}
          onClickHandler={onDecrement}
          isSquared
        />
        <Typography className={classes.input} variant="body1">
          {value}
        </Typography>
        <ActionButton
          className={classes.iconButton}
          type={ACTION_BUTTON_TYPES.PLUS_ONE}
          onClickHandler={onIncrement}
          isSquared
        />
      </div>
      {hasError && errorMessage && (
        <FormHelperText className={classes.errorMessage} error={hasError}>
          {errorMessage}
        </FormHelperText>
      )}
    </div>
  );
};

NumberStepper.propTypes = {
  translations: PropTypes.object.isRequired,
  value: PropTypes.number,
  field: PropTypes.object,
  hasError: PropTypes.bool,
  errorMessage: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default NumberStepper;
